import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-[#E5E5E5]">
      <div className="max-w-3xl mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <button
            data-testid="privacy-back-btn"
            onClick={() => navigate("/")}
            className="flex items-center gap-2 mono-font text-xs text-[#52525B] hover:text-[#17B352] transition-colors uppercase tracking-wider mb-12"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </button>

          <h1 className="text-4xl md:text-5xl mb-4 italic">Privacy Policy</h1>
          <p className="mono-font text-xs text-[#52525B] tracking-wider uppercase mb-12">
            Last updated: February 2026
          </p>

          <div className="space-y-10 text-[#A1A1AA] leading-relaxed">
            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">1. Information We Collect</h2>
              <p>
                When you use our services or submit forms on our website, we may collect the following information:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Name and email address</li>
                <li>Company name and project details</li>
                <li>Language pair preferences and professional experience</li>
                <li>CV or portfolio links you voluntarily provide</li>
                <li>Basic usage analytics (page views, form interactions)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">2. How We Use Your Information</h2>
              <p>We use the collected information to:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Respond to your inquiries and project requests</li>
                <li>Process translator applications and onboarding</li>
                <li>Improve our website and services</li>
                <li>Send relevant communications about our services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">3. Data Storage & Security</h2>
              <p>
                Your data is stored securely using industry-standard encryption and access controls. 
                We retain your information only as long as necessary to fulfill the purposes outlined 
                in this policy or as required by law.
              </p>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">4. Third-Party Services</h2>
              <p>
                We use select third-party services to operate our website, including email delivery 
                and hosting providers. These services process data on our behalf and are bound by 
                their own privacy policies and data protection agreements.
              </p>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Access the personal data we hold about you</li>
                <li>Request correction or deletion of your data</li>
                <li>Withdraw consent for data processing</li>
                <li>Lodge a complaint with a data protection authority</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">6. Cookies & Analytics</h2>
              <p>
                We use basic analytics to understand website usage patterns. No third-party tracking 
                cookies are used. Analytics data is anonymized and stored securely.
              </p>
            </section>

            <section>
              <h2 className="text-2xl text-[#E5E5E5] mb-4">7. Contact Us</h2>
              <p>
                For privacy-related inquiries, please contact us at{" "}
                <a href="mailto:madhiee@graphikpro.com" className="text-[#17B352] hover:underline">
                  madhiee@graphikpro.com
                </a>
              </p>
            </section>
          </div>

          <div className="mt-16 pt-8 border-t border-[#1f1f23]">
            <p className="mono-font text-xs text-[#52525B] tracking-wider">
              © {new Date().getFullYear()} Graphikpro. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
